import { render, staticRenderFns } from "./StaffForm.vue?vue&type=template&id=4e365f11&scoped=true"
import script from "./StaffForm.vue?vue&type=script&lang=js"
export * from "./StaffForm.vue?vue&type=script&lang=js"
import style0 from "./StaffForm.vue?vue&type=style&index=0&id=4e365f11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e365f11",
  null
  
)

export default component.exports